import { render, staticRenderFns } from "./QuestionSolidIcon.vue?vue&type=template&id=28af7bee&"
import script from "./QuestionSolidIcon.vue?vue&type=script&lang=js&"
export * from "./QuestionSolidIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports